import PartnerServices from './Partners/Services';
import GeolocationServices from './Geolocation/Services';
import CmsServices from './Cms/Services';
import SmaplesServices from './Sample/Services';

export const UtilsServices = {
  ...PartnerServices,
  ...GeolocationServices,
  ...CmsServices,
  ...SmaplesServices,
};
